<div mat-dialog-content>
    {{data.infoMessage}}
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
</div>

